import { graphql } from 'gatsby';
import React from 'react';
import { cn, getPositionClass, getSettingsClass } from '~/utils/helpers';

export const fragment = graphql`
  fragment MixedContentFragment on Block {
    settings {
      ...SettingsFragment
    }
    content_alignment
    font_color
    mixed_content {
      ... on MixedContentTextItem {
        __typename
        text
      }
      ... on MixedContentImageItem {
        __typename
        src
        alt
        size
      }
    }
  }
`;

const MixedContentItem = ({ item }: { item: MixedContentItem }) => {
  if (item.__typename === 'MixedContentTextItem') {
    return (
      <span
        className='inline-block'
        dangerouslySetInnerHTML={{ __html: item.text }}
      />
    );
  }

  if (item.__typename === 'MixedContentImageItem') {
    return (
      <img
        className='mx-2 inline-block w-auto'
        src={item.src}
        alt={item.alt}
        style={{
          height: `${item.size}rem`,
        }}
      />
    );
  }

  return null;
};

export default function MixedContent({
  block: { content_alignment, font_color, mixed_content, settings },
}: MixedContentProps) {
  const settingsClass = getSettingsClass(settings);
  const justifyClass = getPositionClass(content_alignment);

  return (
    <div
      className={cn(
        `mx-auto block flex max-w-xl items-center xl:max-w-lg lg:max-w-md md:max-w-sm md:p-4 ${justifyClass} ${settingsClass}`
      )}
      style={{ color: font_color }}
    >
      {mixed_content.map((item, index) => (
        <MixedContentItem
          key={index}
          item={item}
        />
      ))}
    </div>
  );
}
